import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { MemberService } from '@app/services/member.service';
import { MemberofficeService } from '@app/services/memberoffices/memberoffice.service';
import { Sort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';
import { MenuItem, SelectItem, MessageService } from 'primeng/api';
import { CSVDataService } from '@app/export/CSVDataService';
import { NavigationEnd, Router } from '@angular/router';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { from } from 'rxjs';
import { distinctUntilKeyChanged } from 'rxjs/operators';

interface IMember {
  memberId: number;
}
interface OfficeType {
  id: number;
  name: string;
}

interface Office {
  id: number;
  abbreviation: string;
  name: string;
  type: number;
  sort: number;
}

@Component({
  selector: 'app-officereport',
  templateUrl: './officereport.component.html',
  styleUrls: ['./officereport.component.css']
})

export class OfficereportComponent implements OnInit {
  officereportform;
  
  items: MenuItem[];
  officetypelist: OfficeType[] = [];
  officelist: any[] = [];
  committeelist;
  selectedinstitutions: any[] = [];
  displayOfficeInstitutions = false;
  displayInstitutionChooser = false;
  selectedofficeinstitutions: any[] = [];
  membershipselectedinstitutions: any[] = [];
  nomembershipselectedinstitutions: any[] = [];
  result;
  se;
  access;
  someorall: SelectItem[];
  epost: SelectItem[];
  displayMembership = false;
  displayNoMembership = false;
  expanded = true;
  expandedlabel = 'Stäng grupper';
  emailaddresses: any[] = [];
  selectedmembers: any[] = [];
  showMailView = false;
  selectedrole;
  /************* Dateformat ****************************************/
  // maxYear ska sättas dynamiskt.
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private permissionService: PermissionsService,
    private datePipe: DatePipe,
    private memberofficeService: MemberofficeService,
    private memberService: MemberService,
    private messageService: MessageService) {
    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clear();
      }
    });
    this.someorall = [{ label: 'både', value: 'all' }, { label: 'någon av', value: 'some' }];
    this.epost = [{ label: 'Ja', value: 'yes' }, { label: 'Nej', value: 'no' }, { label: 'Båda', value: 'both' }];
  }

  ngOnInit() {
    this.officereportform = this.fb.group({
      officeTypeId: ['', ''],
      officeId: ['', ''],
      committeeId: ['', ''],
      officeInstitutions: ['', ''],
      officeStartPeriodFrom: ['', ''],
      officeStartPeriodTo: ['', ''],
      officeEndPeriodFrom: ['', ''],
      officeEndPeriodTo: ['', ''],
      email1: ['both', ''],
      email2: ['both', ''],
      membershipSomeOrAll: ['some', ''],
      membershipInstitutions: ['', ''],
      membershipStartedFrom: ['', ''],
      membershipStartedTo: ['', ''],
      membershipEndedFrom: ['', ''],
      membershipEndedTo: ['', ''],
      nomembershipSomeOrAll: ['some', ''],
      nomembershipInstitutions: ['', ''],
      nomembershipStartedFrom: ['', ''],
      nomembershipStartedTo: ['', ''],
      nomembershipEndedFrom: ['', ''],
      nomembershipEndedTo: ['', ''],
      parentInstitutionId: ['', ''],
      institutionId: ['', ''],
      institutionTypeId: ['', '']
    });
    this.permissionService.access.subscribe(a => {
      if (a) {
        this.access = a;
      }
    });

    this.permissionService.selectedrole.subscribe(r => {
      if (r) {
        this.selectedrole = r;
      }
    });

    this.se = {
      firstDayOfWeek: 1,
      dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
      dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
      dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
      monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'I dag',
      clear: 'Rensa',
      dateFormat: 'yy-mm-dd',
      weekHeader: 'Vecka'
    };
    this.getOfficesTypes();
    this.getOffices();
    this.getCommittees();
    this.setItems();
  }

  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }, {
        label: 'Epost',
        icon: 'fa fa-envelope-o',
        command: () => this.sendMail(),
        visible: this.selectedmembers?.length > 0 && this.selectedrole.permissions.includes('SEND_EMAIL')
      }, {
        label: 'Etiketter',
        icon: 'fa fa-id-card',
        visible: this.selectedmembers?.length > 0 && this.selectedrole.permissions.includes('VIEW_POSTALS'),
        command: () => this.createLabels()
      }];
  }

  sendMail() {
    this.selectedmembers.forEach(m => {
      m['id'] = m.memberId;
      m['email1'] = m.email;
    });
    this.showMailView = true;
  }

  createLabels() {
    let idlista: any[] = [];
    this.result.forEach(x => {
      idlista.push(x.memberId);
    });
    this.memberService.GetMemberInfoFromMemberIds(idlista).subscribe(x => {
      if (x) {
        let memberlista: any[] = [];
        x.forEach(i => {
          const data = {
            givenName: i.givenName + ' ' + i.familyName,
            careOf: i.careOf,
            street: i.street,
            zipCode: i.zipCode,
            homeCity: i.homeCity,
            homeCountry: i.homeCountry
          };
          memberlista.push(data);
        });
        const firstrow = 'Namn;C/O;Gatuadress;Postnummer;Ort;Land';
        const filnamn = 'OF_Etikettdata_Ämbeten_medlemmar';
        CSVDataService.exportToCsv(filnamn + '.csv', memberlista, firstrow);
      }
    });
  }

  exportToCSV() {
    const firstrow = "Medlemsnummer;Förnamn;Övriga Förnamn;Mellannamn;Efternamn;Tidigare Efternamn;Yrke/Titel;Bostad C/O;Bostad Gata/Box;Bostad Postnummer;Bostad Ort;Bostad Land;Arbete C/O;Arbete Gata/Box;Arbete Postnummer;Arbete Ort;Arbete Land;Annan C/O;Annan Gata/Box;Annan Postnummer;Annan Ort;Annan Land;Telefon 1;Telefon 2;Arbetstelefon;Mobiltelefon;Fax;E-post 1;E-post 2;Hemsida;Invigd datum;Medlemsnummer Fadder;Fadder;Födelsedatum;SOFT - (J/N);Lokalt medlemsnummer;Primärinstitution;Institution.Förkortning;Institution.Namn;Institution.Ort;Institution.Land;Uppdrag.Förkortning;Uppdrag.Namn;Uppdrag.Utskott;Fr o m;T o m";
    const datum = this.datePipe.transform(new Date(), 'yyMMdd');
    const filnamn = 'Uppdrag' + datum;
    let data;
    let dataset: any[] = [];
    this.result.forEach(x => {
      data = {
        memberId: x.memberInfo.id,
        givenName: x.memberInfo.givenName,
        otherForeNames: x.memberInfo.otherForeNames,
        middleName: x.memberInfo.middleName,
        familyName: x.memberInfo.familyName,
        formerName: x.memberInfo.formerName,
        title: x.memberInfo.title,
        careOf: x.memberInfo.h_CareOf,
        street: x.memberInfo.h_Street,
        zipCode: x.memberInfo.h_ZipCode,
        city: x.memberInfo.h_City,
        country: x.memberInfo.h_Country,
        workAddress_careOf: x.memberInfo.w_CareOf,
        workAddress_street: x.workAddress?.w_Street,
        workAddress_zipCode: x.workAddress?.w_ZipCode,
        workAddress_city: x.workAddress?.w_City,
        workAddress_country: x.workAddress?.w_Country,
        otherAddress_careOf: x.workAddress?.o_CareOf,
        otherAddress_street: x.workAddress?.o_Street,
        otherAddress_zipCode: x.memberInfo.o_ZipCode,
        otherAddress_city: x.memberInfo.o_City,
        otherAddress_country: x.memberInfo.h_Country,
        phone1: x.memberInfo.phone ? x.memberInfo.phone + String.fromCharCode(8203) : '',
        phone2: x.memberInfo.phone2 ? x.memberInfo.phone2 + String.fromCharCode(8203) : '',
        phoneWork: x.memberInfo.phoneWork ? x.memberInfo.phoneWork + String.fromCharCode(8203) : '',
        phoneMobile: x.memberInfo.phoneMobile ? x.memberInfo.phoneMobile + String.fromCharCode(8203) : '',
        fax: x.memberInfo.fax ? x.memberInfo.fax + String.fromCharCode(8203) : '',
        email1: x.memberInfo.email1,
        email2: x.memberInfo.email2,
        webSite: x.memberInfo.webSite,
        initiationDate: this.datePipe.transform(x.memberInfo.initiationDate, 'yyyy-MM-dd'),
        mentorMemberId: x.memberInfo.mentor ? x.memberInfo.mentor.memberId : '',
        mentorGivenName: x.memberInfo.mentor?.givenName ? x.memberInfo.mentor?.givenName + ' ' + x.memberInfo.mentor?.familyName : '',
        birthday: this.datePipe.transform(x.memberInfo.birthday, 'yyyy-MM-dd'),
        isSOFTSubscriber: x.memberInfo.isSubscriber ? 'Ja' : 'Nej',
        localId: x.memberInfo.localId,
        primaryInstitution: x.memberInfo.primaryInstitution.shortName + ' ' + x.memberInfo.primaryInstitution.name,
        institutionShortName: x.officeInstitutionShortName,
        institutionName: x.officeInstitutionName,
        institutionSeat: x.officeInstitutionVisitingCity,
        institutionCountry: x.officeInstitutionVisitingCountry,
        officeAbbreviation: x.officeAbbreviation,
        officeName: x.officeName,
        officeCommittee: x.committeeName,
        officeStartDate: this.datePipe.transform(x.officeStartDate, 'yyyy-MM-dd'),
        officeEndDate: this.datePipe.transform(x.officeEndDate, 'yyyy-MM-dd')
      }
      dataset.push(data);
    });
    CSVDataService.exportToCsv(filnamn + '.csv', dataset, firstrow);
  }

  setDate(first, second) {
    const datum = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.officereportform.get(first).patchValue(datum);
    this.officereportform.get(second).patchValue(datum);
  }

  removeSelectedOfficeInstitution(id: number) {
    const idx = this.selectedofficeinstitutions.findIndex(x => x.id === id);
    this.selectedofficeinstitutions.splice(idx, 1);
  }

  removeMembershipSelectedInstitution(id: number) {
    const idx = this.membershipselectedinstitutions.findIndex(x => x.id === id);
    this.membershipselectedinstitutions.splice(idx, 1);
  }

  removeNoMembershipSelectedInstitution(id: number) {
    const idx = this.nomembershipselectedinstitutions.findIndex(x => x.id === id);
    this.nomembershipselectedinstitutions.splice(idx, 1);
  }

  getOfficesTypes() {
    this.memberofficeService.GetOfficesTypes().subscribe(response => {
      this.officetypelist = response;
    });
  }

  getOffices() {
    this.memberofficeService.GetOffices().subscribe(response => {
      this.officelist = response;
      this.officelist.forEach(x => {
        x.officeName = x.committeeName + ': ' + x.officeName;
      });
      // tslint:disable-next-line: max-line-length
     //test this.officelist.unshift({ committeId: null, committeeName: null, id: null, oficeId: null, oficeName: null, officeTypeName: null, sort: null });
    });
  }

  getOfficesByOfficeType(evt) {
    this.memberofficeService.GetOfficesByOfficeType(evt.target.value).subscribe(resp => {
      this.officelist = resp;
      this.officelist.forEach(x => {
        x.officeName = x.committeeName + ': ' + x.officeName;
      });
      // tslint:disable-next-line: max-line-length
      this.officelist.unshift({ committeId: null, committeeName: null, id: null, oficeId: null, oficeName: null, officeTypeName: null, sort: null });
    });
  }

  getCommittees() {
    this.memberofficeService.Committees().subscribe(response => {
      this.committeelist = response;
    });
  }

  getCommitteesByOfficeId(evt) {
    if (evt.value?.officeId) {
      this.officereportform?.patchValue({ officeId: evt.value.officeId });
      this.memberofficeService.getCommitteesByOfficeId(evt.value.officeId).subscribe(resp => {
        this.committeelist = resp;
      });
    } else {
      this.getOffices();
      this.getCommittees();
    }
  }

  clear() {
    this.officereportform?.reset();
    this.result = [];
    this.selectedofficeinstitutions = [];
    this.membershipselectedinstitutions = [];
    this.nomembershipselectedinstitutions = [];
    this.officereportform?.patchValue({ email1: 'both' });
    this.officereportform?.patchValue({ email2: 'both' });
  }

  search() {
    const officeinstitutions: any[] = [];
    this.selectedofficeinstitutions.forEach(i => {
      officeinstitutions.push(i.id);
    });
    const membershipinstitutions: any[] = [];
    this.membershipselectedinstitutions.forEach(i => {
      membershipinstitutions.push(i.id);
    });
    const nomembershipinstitutions: any[] = [];
    this.nomembershipselectedinstitutions.forEach(i => {
      nomembershipinstitutions.push(i.id);
    });
    this.officereportform.get('officeInstitutions').patchValue(officeinstitutions);
    this.officereportform.get('membershipInstitutions').patchValue(membershipinstitutions);
    this.officereportform.get('nomembershipInstitutions').patchValue(nomembershipinstitutions);
    this.memberService.GetOfficeReport(this.officereportform.value).subscribe(response => {
      this.result = response.item2;
      if (response.item1 == '') {
        from(this.result).pipe(distinctUntilKeyChanged<any>('memberId')).subscribe(x => {
          x['checkbox'] = true;
        });
        this.setItems();
      } else {
        this.messageService.add({ severity: 'warn', summary: 'Information', detail: response.item1 });
      }
    });
  }

  sortData(sort: Sort) {
    const data = this.result.slice();
    if (!sort.active || sort.direction === '') {
      this.result = data;
      return;
    }
    this.result = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'memberId': return this.compare(a.memberInfo.id, b.memberInfo.id, isAsc);
        case 'givenName': return this.compare(a.memberInfo.givenName, b.memberInfo.givenName, isAsc);
        case 'familyName': return this.compare(a.memberInfo.familyName, b.memberInfo.familyName, isAsc);
        case 'memberInstitutionShortName': return this.compare(a.memberInstitutionShortName, b.memberInstitutionShortName, isAsc);
        case 'officeInstitutionShortName': return this.compare(a.officeInstitutionShortName, b.officeInstitutionShortName, isAsc);
        case 'memberInstitutionName': return this.compare(a.memberInstitutionName, b.memberInstitutionName, isAsc);
        case 'officeInstitutionVisitingCity': return this.compare(a.officeInstitutionVisitingCity, b.officeInstitutionVisitingCity, isAsc);
        case 'officeName': return this.compare(a.officeName, b.officeName, isAsc);
        case 'committeeName': return this.compare(a.committeeName, b.committeeName, isAsc);
        case 'officeStartDate': return this.compare(a.officeStartDate, b.officeStartDate, isAsc);
        case 'officeEndDate': return this.compare(a.officeEndDate, b.officeEndDate, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string | Date | boolean, b: number | string | Date | boolean, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  setSelectedInstitutions(evt, institutionlist) {
    switch (institutionlist) {
      case 'membership': this.membershipselectedinstitutions = evt;
        break;
      case 'nomembership': this.nomembershipselectedinstitutions = evt;
        break;
      case 'office': this.selectedofficeinstitutions = evt;
        break;
    }
  }

  checkMember(memberid: number) {
    return this.selectedmembers.find(item => item.memberId === memberid);
  }

  add(member, element) {
    if (element.checked) {
      if (!this.checkMember(member.memberId)) {
        this.selectedmembers.push(member);
        const idx = this.result.findIndex(m => m.memberId === Number(member.memberId));
        this.result[idx].checked = true;
      }
    } else {
      this.removeFromArray(member.memberId);
    }
    this.setItems();
  }

  removeFromArray(id: number) {
    const test = this.result.filter(r => r.memberId === id);
    test.forEach(m => {
      m.checked = false;
    });
    const idx = this.selectedmembers.findIndex(item => item.id === id);
    this.selectedmembers.splice(idx, 1);
  }

  checkuncheckAll(element) {
    let value = false;
    element.checked ? value = true : value = false;
    for (const m of this.result) {
      if (m.primaryInstitution !== 'AV1') {
        m.checked = value;
        this.add(m, element);
      }
    }
  }

  closeEmail(evt: any) {
    this.showMailView = false;
    this.setItems();
    this.selectedmembers = [];
  }
}
